<template>
  <PopupBox
    :popup-styles="{ top: 3 }"
    class="task-partner-selector-wrapper"
    placement="bottom-start"
    @visibility-change="handlePopupVisibilityChange"
  >
    <template v-slot:trigger>
      <h2 class="task-partner-selector">
        <slot />
        <PopupToggler :is-open="popupVisible" class="ml-2" />
      </h2>
    </template>
    <template>
      <div class="task-partner-selector-content">
        <PopupMenuList :items="taskPartners" :selected-item="selectedPartners" class="task-partner-selector-menu" />
      </div>
    </template>
  </PopupBox>
</template>

<script>
import { PopupBox, PopupMenuList, popupToggle, PopupToggler } from '@/shared/ui/popup';

export default {
  props: {
    taskPartners: {
      type: Array,
      required: true,
    },
    selectedPartners: {
      type: Object,
      required: false,
      default: () => {
      },
    },
  },
  mixins: [ popupToggle ],
  components: { PopupBox, PopupMenuList, PopupToggler },
};
</script>

<style lang="scss" scoped>
.task-partner-selector {
  font-family: inherit;
  font-size: 20px;
  font-weight: 600;
  cursor: pointer;

  &-menu {
    padding-right: 12px;
  }
}
</style>
